<template>
    <div class="main_box">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content" v-loading="loading">
            <div class="btn_group">
                <div
                    :class="['btn_item',activeName=='jobPermission'? 'btn_active':'']"
                    @click="typeClick('jobPermission')"
                >岗位权限分配</div>
                <div
                    :class="['btn_item',activeName=='personPermission'? 'btn_active':'']"
                    @click="typeClick('personPermission')"
                >特殊权限分配</div>
            </div>
            <div class="permission_wrap">
                <div class="pmleft">
                    <div class="pmleft_header">Source</div>
                    <div class="pmleft_search" v-show="activeName=='personPermission'">
                        <el-input
                            style="width:60%;"
                            v-model="personForm.username"
                            size="mini"
                            placeholder="请输入搜索名称"
                            @change="getPersons()"
                        ></el-input>
                        <el-checkbox v-model="personForm.isResoures" @change="getPersons()">已分配</el-checkbox>
                    </div>
                    <div class="pmleft_content" v-show="activeName=='personPermission'">
                        <div
                            :class="['person_item',selectedPersonId==item.userId?'person_active':'']"
                            v-for="(item,index) in personList"
                            :key="index"
                            @click="personClick(item.userId)"
                        >
                            <div class="p_name">{{item.username}}</div>
                            <div class="p_position">{{item.positions}}</div>
                            <i
                                :class="[item.isResoures ? 'el-icon-delete':'', 'p_del']"
                                @click.stop="delPersonResource(item.userId)"
                            ></i>
                        </div>
                    </div>
                    <div
                        class="pmleft_content"
                        style="padding:15px 0 0 8px;"
                        v-show="activeName=='jobPermission'"
                    >
                        <el-tree
                            :data="jobTreeData"
                            show-checkbox
                            check-strictly
                            default-expand-all
                            node-key="id"
                            ref="tree"
                            highlight-current
                            check-on-click-node
                            :props="defaultProps"
                            @check="handleTreeClick"
                        ></el-tree>
                    </div>
                </div>
                <div class="pmright">
                    <div class="pmright_top">
                        <div class="pmright_group" v-for="(item,index) in data" :key="index">
                            <div class="pmright_title">
                                <span>{{item.resourceName}}</span>
                                <el-button
                                    size="mini"
                                    type="primary"
                                    class="el-icon-check"
                                    @click="areaAll(item.id)"
                                ></el-button>
                            </div>
                            <div class="items_group">
                                <div class="permiss_item" v-for="(e,i) in item.children" :key="i">
                                    <el-checkbox v-model="e.checked">{{e.resourceName}}</el-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section class="pmright_foot">
                        <el-button plain size="mini" @click="clearAll">清 空</el-button>
                        <el-button type="primary" size="mini" @click="save">保 存</el-button>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            activeName: 'jobPermission',
            data: [],
            personForm: {
                "firmId": 0,
                "isResoures": false,
                "username": ""
            },
            departmentList: [],
            jobsList: [],
            personList: [],
            selectedJobId: 0,
            selectedJobName: '',
            selectedPersonId: 0,
            selectedPersonName: '',
            jobTreeData: [],
            defaultProps: {
                children: 'positionInfoEntityList',
                label: 'name'
            }
        }
    },
    computed: {
        firmId() {
            let firmInfo = JSON.parse(sessionStorage.getItem("session")).firmInfo;
            if (firmInfo) {
                return firmInfo.id;
            }
            return "";
        },
        // selectedJobName() {
        //     if (this.jobsList.length > 0) {
        //         let obj = this.jobsList.find(e => e.id == this.selectedJobId) || { name: '' }
        //         return obj.name
        //     } else return ''
        // },
        // selectedPersonName() {
        //     if (this.personList.length > 0) {
        //         let obj = this.personList.find(e => e.id == this.selectedPersonId) || { username: '' }
        //         return obj.username
        //     } else return ''
        // },
    },
    mounted() {
        this.getPermissionData()
        this.getJobDto()
        this.getPersons()
    },
    methods: {
        getJobDto() {
            this.ajax.get('/department/admin/getDepartmentPositionListDto?firmId=' + this.firmId).then(res => {
                if (res) {
                    this.jobTreeData = res.map(e => {
                        return {
                            name: e.name,
                            disabled: true,
                            positionInfoEntityList: e.positionInfoEntityList
                        }
                    })
                }
            })
        },
        getPersons() {
            this.personForm.firmId = this.firmId
            if (!this.personForm.isResoures) this.personForm.isResoures = ''
            this.ajax.post('/resoures_user/admin/getUserResouresByFirmId', this.personForm).then(data => {
                console.log(data)
                this.personList = data
            })
        },
        getPermissionData() {
            this.loading = true
            this.ajax.post('/resoures/admin/getResouresPageList', {
                pageNum: 1,
                pageSize: 500,
                param: {
                    "app": "",
                    "id": "",
                    "resourceName": ""
                }
            }).then(res => {
                let resouceList = res.list
                let appsList = [...new Set(resouceList.map(e => e.app))]
                this.data = appsList.map(app => {
                    let children = resouceList.reduce((acc, cur) => {
                        if (cur.app == app) {
                            cur.checked = false
                            acc.push(cur)
                        }
                        return acc
                    }, [])
                    return {
                        id: app,
                        resourceName: app,
                        children
                    }
                })
                this.loading = false
            })
        },
        getPermissionById(id) {
            let url, queryCondition
            switch (this.activeName) {
                case 'jobPermission':
                    queryCondition = 'positionId'
                    break;
                case 'personPermission':
                    queryCondition = 'userId'
                    break;
                default:
                    return;
            }
            this.ajax.get(`/resoures/admin/getResouresListByUserIdOrPonId?${queryCondition}=${id}`).then(res => {
                if (res) {
                    const resourceIds = res.map(e => e.id)
                    for (const item of this.data) {
                        if (item.children) {
                            for (const childItem of item.children) {
                                if (resourceIds.indexOf(childItem.id) !== -1) {
                                    childItem.checked = true
                                } else childItem.checked = false
                            }
                        }
                    }
                }
            })
        },
        clearAll() { //清除所有勾选
            for (const item of this.data) {
                if (item.children) {
                    for (const childItem of item.children) {
                        childItem.checked = false
                    }
                }
            }
        },
        save() {
            let url, form;
            let treeKeys = this.data.reduce((acc, cur) => {
                if (cur.children) {
                    for (const item of cur.children) {
                        if (item.checked) acc.push(item.id)
                    }
                }
                return acc
            }, [])
            switch (this.activeName) {
                case 'jobPermission':
                    url = '/resouresPosition/api/addResouresPosition'
                    form = {
                        "positionId": this.selectedJobId,
                        "resourceAppIds": treeKeys.filter(e => typeof e === 'number')
                    }
                    break;
                case 'personPermission':
                    url = '/resoures_user/admin/addOrUpdResouresOneUser'
                    form = {
                        "resourceAppIds": treeKeys.filter(e => typeof e === 'number'),
                        "userId": this.selectedPersonId
                    }
                    break;
                default:
                    return;
            }
            this.ajax.post(url, form).then(res => {
                if (res) {
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                    if (this.activeName == 'personPermission') this.getPersons()
                }
            })
        },
        typeClick(type) {
            this.activeName = type
            // 切换清空数据
            this.clearAll()
            this.selectedPersonId = 0
            this.$refs.tree.setCheckedKeys([])
        },
        handleTreeClick(data, treeObj) {
            if (treeObj.checkedKeys.length > 1) { //单选
                this.$refs.tree.setCheckedKeys([data.id]);

            }
            if (treeObj.checkedKeys.length == 0) {
                this.clearAll()
                this.selectedJobId = 0
            } else {
                this.getPermissionById(data.id)
                this.selectedJobId = data.id
            }
        },
        areaAll(idName) {
            let data = this.data.find(e => e.id == idName) || { children: [] }
            data.children.forEach(element => {
                element.checked = true
            });
        },
        personClick(id) { //点击person切换资源
            this.selectedPersonId = id
            this.getPermissionById(id)
        },
        delPersonResource(id) {
            if (id) {
                this.$confirm('此操作将永久删除该用户权限, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let url, form = { resourceAppIds: [] }
                    switch (this.activeName) {
                        case 'jobPermission':
                            url = '/resouresPosition/api/addResouresPosition'
                            form.positionId = id
                            break;
                        case 'personPermission':
                            url = '/resoures_user/admin/addOrUpdResouresOneUser'
                            form.userId = id
                            break;
                        default:
                            return;
                    }
                    this.ajax.post(url, form).then(res => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            })
                            if (this.activeName == 'personPermission') this.getPersons()
                        }
                    })
                }).catch(err => { console.log(err) })
            }
        }

    }
}
</script>
<style lang="scss"  scoped>
.btn_group {
    display: flex;
    margin-bottom: 10px;
    .btn_item {
        width: 150px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        box-sizing: border-box;
        font-size: 15px;
        background: #cccccc;
        color: #fff;
        border-radius: 8px;
        cursor: pointer;
        margin-right: 10px;
    }
    .btn_item:hover,
    .btn_active {
        background: #0080c0;
    }
}
.permission_wrap {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 15px;
}
.pmleft {
    width: 300px;
    height: 70vh;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-bottom: 10px;
    border: 1px solid #e1e9f6;
    &_header {
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        background: #e1e9f6;
        color: #000;
        font-size: 18px;
        font-weight: 600;
        padding: 0 5px;
    }
    &_search {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 3px;
    }
    &_content {
        width: 100%;
        padding: 0 5px;
    }
    .person_item {
        width: 100%;
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #d1e0f8;
        padding: 0 10px;
        cursor: default;
        .p_name {
            width: 4em;
            font-size: 15px;
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #409eff;
        }
        .p_position {
            width: 60%;
            font-size: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #3c3c3c;
        }
        .p_del {
            width: 20px;
            z-index: 99;
            cursor: pointer;
            font-size: 20px;
            color: rgb(212, 29, 29);
        }
    }
    .person_active,
    .person_item:hover {
        background: #e7f0ff;
    }
}
// right
.pmright {
    width: calc(100% - 300px);
    overflow: hidden;
    padding: 15px;
    border: 1px solid #d2e6f6;
    border-left: none;
    height: 70vh;
    &_top {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: calc(70vh - 60px);
        overflow-y: auto;
    }
    &_foot {
        height: 30px;
    }
    &_group {
        width: 100%;
        padding: 0 15px 10px;
    }
    &_title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 0 8px 5px;
        font-size: 20px;
        border-bottom: 1px solid #e1e9f6;
        height: 32px;
    }
    .items_group {
        width: 100%;
        padding: 0 8px 30px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
        .permiss_item {
            width: 33%;
            margin-top: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/basic/permission.vue